"use client";

import { useEffect } from "react";
import { trackEvent } from "@/lib/trackEvent";

/**
 * Fires the same phone_number events as <PhoneLink> for plain tel: links
 * inside blog post HTML (which is injected as a string and can't use PhoneLink).
 */
export default function BlogTelTracker() {
  useEffect(() => {
    const handleClick = (e) => {
      const link = e.target.closest?.('.blog-content a[href^="tel:"]');
      if (!link) return;
      trackEvent("phone_number", 50);
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return null;
}
